import PrescribedHoursPage from './PrescribedHoursPage';

export default PrescribedHoursPage;
